import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Icon, Button, Search, Message } from 'semantic-ui-react';
import { DyzioModalHeader } from 'dyzio-shared-components/lib/components/dyzio-modal';

const inputProps = {
  placeholder: 'New campaign...',
};
const centerText = {
  textAlign: 'center',
};
const RollForwardModal = ({
  onClose,
  selected,
  searchHandler,
  selectedHandler,
  options,
  loading,
  searched,
  yepButtonHandler,
  isRolling,
}) => (
  <Modal open onClose={onClose} size="small">
    <DyzioModalHeader headerText="Influencer Roll Forward" onClose={onClose} />
    <Modal.Content style={centerText} >
      <Search
        fluid
        className="full-width"
        input={inputProps}
        loading={loading}
        showNoResults={searched}
        minCharacters={3}
        results={options}
        onSearchChange={searchHandler}
        onResultSelect={selectedHandler}
      />
    </Modal.Content>
    <Modal.Content>
      <Message>
        {(selected && `Roll influencer forward to ${selected.title}`) || 'Please choose new campaign above'}
      </Message>
    </Modal.Content>
    <Modal.Actions>
      <Button color="pink" onClick={onClose}>
        <Icon name="remove" />
          Cancel
      </Button>
      <Button color="green" disabled={!selected} onClick={yepButtonHandler} loading={isRolling}>
        <Icon name="checkmark" />
          Yep
      </Button>
    </Modal.Actions>
  </Modal>
);

RollForwardModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  selected: PropTypes.object.isRequired,
  searchHandler: PropTypes.func.isRequired,
  yepButtonHandler: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selectedHandler: PropTypes.func.isRequired,
  searched: PropTypes.bool.isRequired,
  isRolling: PropTypes.bool.isRequired,
};

export default RollForwardModal;



/** WEBPACK FOOTER **
 ** ./src/components/roll-forward-modal/index.js
 **/